import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { ErrorPage } from 'pages/error';
import { Landing } from 'pages/landing';
import { IosPage } from 'pages/ios-page';
// eslint-disable-next-line no-restricted-imports
import { App } from '../ui/App';
import { LicenseAgreementsPage, AnnexDpaPage } from 'pages/agreements';

export const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                path: '/login',
                element: <Landing />,
                errorElement: <ErrorPage />,
            },
            {
                path: '/error',
                element: <ErrorPage />,
            },
            {
                path: '/GetApp/kes_ios',
                element: <IosPage />,
            },
            {
                path: '/Home/LegalDocuments',
                element: <LicenseAgreementsPage />,
            },
            {
                path: '/Home/AnnexDPA',
                element: <AnnexDpaPage />,
            },
        ],
    },
]);
